const canUseEnv = typeof process !== "undefined" && Boolean(process.env);

export const isUnitTest = (() => {
  // https://stackoverflow.com/questions/50940640/how-to-determine-if-jest-is-running-the-code-or-not
  if (typeof process !== "undefined" && process.env.JEST_WORKER_ID) {
    return true;
  }
  return false;
})();

export const isDevelopment =
  !isUnitTest && canUseEnv && process.env.NODE_ENV === "development";

const shouldUseLocalHttps =
  typeof process !== "undefined" && process.env.REPLO_LOCAL_HTTPS === "true";
const shouldUseLocalProdData =
  typeof process !== "undefined" &&
  process.env.REPLO_LOCAL_PROD_DATA === "true";

// WebSocket URL for multiplayer editor functionality
export const WEBSOCKET_BASE_URL = isDevelopment
  ? "ws://localhost:3009"
  : "wss://multiplayer.reploapi.com";

/**
 * The default values we should provide to the `credentials` option of fetch()
 * when we're calling our backend in the editor.
 */
export const defaultFetchCredentials = (() => {
  // Note (Noah, 2025-07-18, REPL-18040): "include" is the default, because we
  // want requests to our backend to respect the Set-Cookie header so that cookies
  // can propagate to subsequent requests. "same-origin" does not work because
  // dashboard.replo.app and api.replo.app are different origins.
  //
  // This is fine for CSRF, because our cookies have SameSite=Lax so they'll never
  // be sent by malicious impersonating javascript, and we don't even use cookies
  // for auth anyway (currently).
  return "include" as const;
})();

export function getPublisherUrl() {
  // NOTE (Chance 2023-06-19) The staging URL can be enabled in any environment
  // with a setting in the debug menu. Noah made a suggestion for a potentially
  // better abstraction but we needed to push this out and didn't want to spend
  // more time thinking about it!
  // https://github.com/replohq/andytown/pull/4662/files#r1234563041
  if (localStorage.getItem("replo.debug.usePublisherStagingUrl") === "true") {
    return "https://replo-publisher-staging.fly.dev";
  }

  // Note (Noah, 2025-07-17): isDevelopment is actually false in e2e tests, so we have
  // to check for localhost. Pretty sure there's a better way to do this
  if (
    !shouldUseLocalProdData &&
    (isDevelopment || window.location.hostname === "localhost")
  ) {
    return shouldUseLocalHttps
      ? "https://localhost:3004"
      : "http://localhost:3004";
  }
  return "https://api.replo.app";
}

export function getDashboardUrl() {
  // Note (Noah, 2025-07-17): isDevelopment is actually false in e2e tests, so we have
  // to check for localhost. Pretty sure there's a better way to do this
  if (isDevelopment || window.location.hostname === "localhost") {
    return "http://localhost:3000";
  }
  return "https://dashboard.replo.app";
}

export const SHOPIFY_APP_LISTING_URL = "https://apps.shopify.com/alchemy";
